import React, { createRef, useRef, useState } from "react";
import InputField from "../../../generic/inputField";
import RadioButton from "../../../generic/radioButton";
import TocDropdown from "../../../generic/tocDropdown";
import { IListObj } from "../../../types/genericTypes";
import { getCountryList } from "../../../service/generic/otherApi";
import { alphaNumExp } from "../../../utils/regex";
import { forEachChild } from "typescript";

const radioValues1: Array<IListObj> = [
  { value: "TIN", display: "TIN" },
  { value: "Others", display: "Others" },
];

export const TaxResident = (props: any) => {
  const [listCountry, setListCountry] = useState<any | null>([]);
  const [selectCountry, setSelectedCountry] = useState<any>();

  React.useEffect(() => {
    getCountryDetails();
  }, []);
  React.useEffect(() => {
    scrollOnClick();
  }, []);

  const scrollOnClick = (id = 0) => {
    setTimeout(() => {
      const section = window.document.querySelector(`#fatca${id}`);
      section?.scrollIntoView({ behavior: "smooth" });
    }, 0);
  };
  React.useEffect(() => {
    if (props.taxForm) {
      for (let i = 0; i < props.taxForm.length; i++) {
        if (props.taxForm[i].idTypeOther === "Others") {
          let dataup = [...props.taxForm];
          dataup[i] = { ...props.taxForm[i] };
          dataup[i].idTypeOther = "";
          props.SetTaxForm(dataup);
        }
      }
    }
    return () => {};
  }, [props.taxForm, props.error]);
  const openSRErrorPopup = () => {
    props.onSubmit("FATCA Update", {
      headerText:
        "There was some problem in raising service request. Please try again later.",
    });
  };
  const getCountryDetails = async () => {
    try {
      let countryOfList = await getCountryList("Country");
      if (
        countryOfList &&
        countryOfList.data.enumlist.length > 0 &&
        listCountry.length < 100
      ) {
        let arr: any = [];
        countryOfList.data.enumlist.forEach((element: any) => {
          arr.push(element.displayItem);
        });
        arr.sort();
        const countryL = arr.map((list: any) => {
          return { value: list, display: list };
        });
        setListCountry([...countryL]);
      }
    } catch (error) {
      openSRErrorPopup();
    }
  };

  const remove = (id: any) => {
    let obj = [...props.taxForm];
    obj.splice(id, 1);
    props.SetTaxForm(obj);
  };
  const onSet = (name: string, value: any, id: any) => {
    for (let i = 0; i < props.taxForm.length; i++) {
      if (name === "idNo" || name === "idTypeOther" || name === "country") {
        if (i === id) {
          let dataup = [...props.taxForm];
          if (name === "idNo") {
            dataup[id] = {
              ...props.taxForm[id],
              [`${name}`]: value,
              [`${"idNoError"}`]: "",
              [`${"nodisplayError"}`]:
                value.length > 0
                  ? alphaNumExp.test(value)
                    ? ""
                    : "Enter valid Identification Number"
                  : "",
            };
          } else {
            dataup[id] = {
              ...props.taxForm[id],
              [`${name}`]: value,
            };
          }
          props.SetTaxForm(dataup);
        }
      } else {
        if (i === id) {
          let dataup = [...props.taxForm];
          dataup[id] = { ...props.taxForm[id], [`${name}`]: value };
          dataup[id].idType = dataup[id]["idType" + id];
          dataup[id].idTypeOther = dataup[id]["idType" + id];
          props.SetTaxForm(dataup);
        }
      }
    }
  };

  return (
    <>
      {props.taxForm &&
        props.taxForm.map((obj: any, id: any) => (
          <div className="fatca_inputWrap" id={"fatca" + id}>
            {id !== 0 && (
              <div className="blockHead flex-wrap content-space-between align-center">
                <div>
                  <h5 className="field-subHead bold-text">
                    Tax Resident Country {id + 1}
                  </h5>
                </div>
                <div className="flex-wrap">
                  <span className="edel-icon-close"></span>
                  <p
                    className="removeBlock"
                    onClick={() => {
                      remove(id);
                    }}
                  >
                    Remove
                  </p>
                </div>
              </div>
            )}
            <div className="custom--row">
              <div className="custom-col ">
                <label className="input-label">Country</label>
                {listCountry && listCountry.length > 0 && (
                  <TocDropdown
                    selectedValue={obj.country ? obj.country : ""}
                    dropdownOptions={
                      listCountry
                        ? selectCountry
                          ? listCountry.filter(
                              (country: any) => country.value !== ""
                            )
                          : listCountry
                        : []
                    }
                    onSelect={(value: any) => {
                      onSet("country", value, id);

                      setSelectedCountry(value);
                    }}
                    isSearchable={true}
                  />
                )}
              </div>
              <div className="custom-col input-indentify">
                <label className="input-label ">Identification Type</label>
                <div className="identifyTypeRadio">
                  <RadioButton
                    list={radioValues1[0]}
                    name={"idType" + id ? "idType" + id : obj.idType}
                    onChange={(elem) =>
                      onSet(elem.target.name, elem.target.value, id)
                    }
                    selected={
                      props.taxForm[id]["idType" + id]
                        ? props.taxForm[id]["idType" + id]
                        : obj.idTypeOther
                    }
                  />
                  <RadioButton
                    list={radioValues1[1]}
                    name={"idType" + id}
                    onChange={(elem) =>
                      onSet(elem.target.name, elem.target.value, id)
                    }
                    selected={
                      props.taxForm[id]["idType" + id]
                        ? props.taxForm[id]["idType" + id]
                        : obj.idType
                    }
                  />
                </div>
              </div>
            </div>
            <div className="custom--row identifyRow">
              <div className="custom-col ">
                <label className="input-label">
                  {obj.idTypeOther === "TIN"
                    ? "Identification Type"
                    : "Identification Type-Other"}
                </label>
                <InputField
                  defaultValue={obj.idTypeOther ? obj.idTypeOther : ""}
                  onChange={(value) => {
                    onSet("idTypeOther", value.trim(), id);
                  }}
                  onBlur={() => {}}
                  disabled={
                    props.taxForm[id]["idTypeOther"] === "TIN" ? true : false
                  }
                  placeholder={
                    obj.idTypeOther !== "" ? "TIN" : "Enter Identification Type"
                  }
                />
              </div>
              <div className="custom-col">
                <label className="input-label">Identification Number</label>
                <InputField
                  defaultValue={
                    props.taxForm[id].idNo ? props.taxForm[id].idNo : ""
                  }
                  onChange={(value) => {
                    onSet("idNo", value.trimStart(), id);
                  }}
                  onMouseOut={(value: any) => {
                    let dataup = [...props.taxForm];
                    dataup[id] = {
                      ...props.taxForm[id],
                      [`${"idNoError"}`]:
                        value.length > 0
                          ? alphaNumExp.test(value)
                            ? ""
                            : "Enter valid Identification Number"
                          : "",
                    };
                    props.SetTaxForm(dataup);
                  }}
                  onBlur={() => {}}
                  pattern={alphaNumExp}
                  errorText={props.taxForm[id]["idNoError"]}
                />
              </div>
            </div>
          </div>
        ))}
      {props.taxForm && props.taxForm.length < 3 && (
        <button type="button" className="ed_button common_button noBg-btn">
          <span className="edel-icon-plus"></span>
          <span
            onClick={() => {
              if (props.taxForm.length < 3) {
                scrollOnClick(props.taxForm.length);
                props.SetTaxForm([
                  ...props.taxForm,
                  {
                    country: "",
                    idType: "",
                    idNo: "",
                    idTypeOther: "TIN",
                    idNoError: "",
                    nodisplayError: "",
                  },
                ]);
              }
            }}
          >
            Add Another Tax Resident Country
          </span>
        </button>
      )}
    </>
  );
};
